<template>
  <div class="all">
    <div class="pad">
      <div
        @click="
          $router.push({ path: '/' });
          window.scrollTo(0, 0);
        "
        style="cursor: pointer"
      >
        <img
          src="../assets/images/logo.png"
          style="width: 150px; margin-top:25px"
        />
      </div>

      <div class="tab">
        <div class="title3" style="">
          <a
            :class="[$route.path == '/instruction' ? 'title_hover' : 'title']"
            style="padding-bottom: 26px"
            @click="goPage('instruction')"
            >品牌</a
          >
        </div>
        <div class="title1">
          <a
            :class="[
              $route.path == '/productList' ||
              $route.params.id == 1 ||
              $route.params.id == 2 ||
              $route.params.id == 3
                ? 'title_hover'
                : 'title'
            ]"
            style="padding-bottom: 26px; z-index:30"
            >产品</a
          >
          <div class="product">
            <el-divider style="margin-top:-2px"></el-divider>
            <div class="product1">
              <div>
                <div class="img_show" @click="goPage('productDetails', 3)">
                  <div style="margin:auto; display:flex">
                    <img
                      src="../assets/images/product3/product.png"
                      style="height:140px; width:auto; margin-top:10px"
                    />
                  </div>
                </div>
                <p class="img_span" style="margin-top:10px;">
                  NZONE S7
                </p>
              </div>
              <div>
                <div
                  class="img_show"
                  @click="goPage('productDetails', 2)"
                  style="margin-left:50px"
                >
                  <div style="margin:auto; display:flex;">
                    <img
                      src="../assets/images/product2/purple.png"
                      class="img1"
                    />
                    <img
                      src="../assets/images/product2/front.png"
                      class="img1"
                      style="margin-left:-170px"
                    />
                  </div>
                </div>
                <p class="img_span" style="margin-top:10px;margin-left:50px">
                  NZONE S7 Pro+ 5G
                </p>
              </div>

              <div>
                <div
                  class="img_show"
                  @click="goPage('productDetails', 1)"
                  style="margin-left:50px"
                >
                  <div style="margin:auto; display:flex">
                    <img
                      src="../assets/images/product1/back.png"
                      class="img2"
                    />
                    <img
                      src="../assets/images/product1/front.png"
                      class="img2"
                      style="margin-left:-120px"
                    />
                  </div>
                </div>
                <p class="img_span" style="margin-top:10px; margin-left:50px">
                  NZONE S7 Pro
                </p>
              </div>
                            <div>
                <div
                  class="img_show"
                  @click="goPage('productDetails', 4)"
                  style="margin-left:50px"
                >
                  <div style="margin:auto; display:flex">
                    <!-- <img
                      src="../assets/images/product1/back.png"
                      class="img2"
                    />
                    <img
                      src="../assets/images/product1/front.png"
                      class="img2"
                      style="margin-left:-120px"
                    /> -->
                    <img src="../assets/images/product4/instruct1.png" class="img2" style="width:110px; height: 140px">
                  </div>
                </div>
                <p class="img_span" style="margin-top:10px; margin-left:50px">
                  NZONE 50 Pro
                </p>
              </div>
            </div>

            <!-- <div style="margin-top: 30px; display:flex; justify-content:center">
          <el-button
            class="button"
            @click="goPage('productList')"
            >查看全部</el-button
          >
        </div> -->
          </div>
        </div>
        <div class="title2" style="">
          <a
            :class="[
              $route.path == '/shop' ||
              $route.path == '/query' ||
              $route.path == '/repair' ||
              $route.path == '/problems' ||
              $route.path == '/service' ||
              $route.path == '/query'
                ? 'title_hover'
                : 'title'
            ]"
            style="padding-bottom: 26px"
            @click="goPage('service')"
            >服务支持</a
          >

          <!-- <div class="service" style="">
          <el-divider class="divider"></el-divider>
      
        <div style="margin-top: 5px">
          <span
            :class="[($route.path == '/shop')?'titlez_hover' :'titlez']"
            style="font-size: 16px; padding-bottom: 30px; margin-left: 55.5vw"
            @click="goPage('shop')"
            >服务门店</span>
          <span
            :class="[($route.path == '/repair')?'titlez_hover' :'titlez']"
            style="font-size: 16px; padding-bottom: 30px; margin-left:5vw"
            @click="goPage('repair')"
            >保修政策</span
          >
          <span
            :class="[($route.path == '/problems')?'titlez_hover' :'titlez']"
            style="font-size: 16px; padding-bottom: 30px; margin-left:5vw"
            @click="goPage('problems')"
            >常见问题</span
          >
          
        </div>
      </div> -->
        </div>

        <!-- <div class="title3" style="">
      <a :class="[($route.path == '/message'||$route.path == '/messageTable')?'title_hover' :'title']" style="padding-bottom: 26px" @click="goPage('message')"
        >预置应用公示</a
      >
    </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 0,
      path: "",
      show1: false,
      show2: false,
      show3: false,
      imgList: [
        {
          name: "1",
          imgsrc: require("../assets/images/product1.png")
        },
        {
          name: "2",
          imgsrc: require("../assets/images/product2.png")
        }
      ]
    };
  },
  methods: {
    goPage(path, id) {
      this.$router.push({ name: path, params: { id: id } });
      setTimeout(() => {
        window.location.reload();
      }, 100);
      window.scrollTo(0, 0);
    },

    openshop(url) {
      window.open(url);
    },

    change1() {
      if (this.show1 == true) {
        this.show1 = false;
      } else {
        this.show1 = true;
      }
    },

    change2() {
      if (this.show2 == true) {
        this.show2 = false;
      } else {
        this.show2 = true;
      }
    }

    // change3(){
    //   if(this.show3 == true){
    //     this.show3 = false
    //   }else{
    //     this.show3 = true
    //   }

    // }
  }
};
</script>

<style scoped>
.pad {
  max-width: 1300px;
  min-width: 800px;
  padding: 0;
  display: flex;
  z-index: 10;
  background-color: white;
  justify-content: space-between;
  flex-shrink: 0;
  height: 85px;
  /* overflow: auto; */
}

.all {
  width: 100%;
  padding: 0;
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: white;
  justify-content: center;
  flex-shrink: 0;
  height: 85px;
  /* overflow: auto; */
}
.title {
  font-size: 18px;
  font-weight: regular;
  font-style: SourceHanSansSC-regular;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
  z-index: 2;
}

.title_4 {
  font-size: 20px;
  font-weight: bold;
  font-style: SourceHanSansSC-regular;

  color: white;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
}

.title:hover {
  font-size: 18px;
  font-weight: regular;
  font-style: SourceHanSansSC-regular;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 20px;
  margin-bottom: 0;
  padding-bottom: 20px;
  border-bottom: 2px solid black;
  z-index: 2;
}
.product {
  display: none;
  width: 100vw;
  position: absolute;
  text-align: left;
  background-color: white;
  left: 0;
  z-index: 1;
  padding-bottom: 20px;
  margin-top: 35px;
  flex-shrink: 0;
  text-align: center;
}

.title1:hover .product {
  display: block;
  width: 100vw;
  position: absolute;
  text-align: left;
  background-color: white;
  left: 0;
  z-index: 1;
  padding-bottom: 20px;
  margin-top: 26px;
  flex-shrink: 0;
  text-align: center;
}

.service {
  width: 160vw;
  display: none;
  position: absolute;
  /* text-align: left; */
  z-index: 1;
  left: -106vw;
  background-color: white;
  padding-bottom: 30px;
  margin-top: 28px;
  padding-top: 35px;
}

.title2:hover .service {
  width: 160vw;
  display: block;
  position: absolute;
  /* text-align: left; */
  z-index: 1;
  left: -106vw;
  background-color: white;
  padding-top: 45px;
  padding-bottom: 30px;
}
.title1 {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-bold;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
}

.title0 {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-bold;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
}

.title2 {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-bold;
  position: relative;
  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
}
.title3 {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-bold;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
}

.title4 {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-bold;
  color: white;
  text-decoration: none;
  cursor: pointer;
  /* margin-left:8vw; */
  display: flex;
  align-items: flex-start;
  margin-top: 25px;

  /* margin-top: 40px; */
}

.img_show {
  width: 200px;
  padding: 0;
  border-radius: 5%;
  display: flex;
  height: 200px;
  justify-content: center;
  background-color: #f5f6f9;
}

.img1 {
  margin-top: 10px;
  height: 170px;
  border-radius: 10%;
  padding-left: 20px;
  padding-right: 20px;
}

.img2 {
  margin-top: 10px;
  height: 180px;
  border-radius: 10%;
  padding-left: 20px;
  padding-right: 20px;
}

.img_span {
  font-size: 16px;
  margin-bottom: 1vw;
  margin-top: 20px;
}

.button {
  background-color: black;
  width: 150px;
  color: white;
  font-size: 16px;
  border-radius: 20px;
  border-color: black;
}

.button:hover {
  background-color: white;
  width: 150px;
  color: black;
  font-size: 16px;
  border-radius: 20px;
  border-color: black;
}

.product1 {
  display: flex;
  width: 100%;
  margin-top: 10px;
  justify-content: center;
  margin-left: -45px;
}

.title_hover {
  font-size: 18px;
  font-weight: regular;
  font-style: SourceHanSansSC-regular;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
  margin-bottom: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid black;
  z-index: 2;
}

div {
  transition: all 0.3s ease;
}

.tab {
  display: flex;
  /* margin-right: 9vw; */
  justify-content: space-between;
  flex-shrink: 0;
  width: 25vw;
  min-width: 400px;
  margin-left: 35vw;
}

.button1 {
  color: white;
  background-color: black;
  border-radius: 20px;
  width: 180px;
  height: 40px;
  flex-shrink: 0;
  font-size: 18px;
  font-style: Roboto;
  border-color: black;
  cursor: pointer;
}

.button1:hover {
  color: black;
  background-color: white;
  border-radius: 20px;
  width: 180px;
  height: 40px;
  flex-shrink: 0;
  font-size: 18px;
  font-style: Roboto;
  border-color: black;
  cursor: pointer;
}

.title5:hover {
  background-color: white;
}

.content {
  font-size: 16px;
  font-family: SourceHanSansSC-regular;
  color: black;
  margin-left: 15px;
  letter-spacing: 1px;
}

.content1 {
  font-size: 14px;
  font-family: SourceHanSansSC-regular;
  color: black;
  margin-left: 10px;
  letter-spacing: 1px;
}

.flex {
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
}

.flex:hover {
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;

  background-color: #ebeced;
}

.flex1 {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
}

.flex1:hover {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;

  background-color: #ebeced;
}

.showing {
  display: none;
}

.title4:hover .showing {
  display: block;
}

.mobile .code {
  display: block;
}

.titlez_hover {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-regular;

  color: black;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
  margin-bottom: 0;
  padding-bottom: 10px;
  /* border-bottom: 2px solid red; */
  z-index: 2;
  font-weight: bold;
}

.titlez {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-regular;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
  z-index: 2;
}

.titlez:hover {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-regular;

  color: black;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 30px;
  margin-bottom: 0;
  padding-bottom: 10px;
  /* border-bottom: 2px solid red; */
  z-index: 2;
}

.divider {
  margin-top: -47px;
  z-index: -1;
  margin-bottom: 45px;
}

/* .title:after{
  content: "";
    width: 0;
    height: 1px;
    background: blue;
    position: absolute;
    top: 90%;
    left: 50%;
    transition: all .8s;
}

.title:hover:after{
  left: 0;
   width: 100%;
} */
</style>
